import { useSelector } from 'react-redux';

export const PLATFORM_PADDLE = 'paddle';
export const PLATFORM_STRIPE = 'stripe';

export const PADDLE_HELP_URL = 'https://www.paddle.net/';

// The subscription the user is currently on. Mirrors the derivation in
// ManageSubscription, and deliberately differs from the "has or has had"
// check in Support/CriticReport, which also matches ended subscriptions.
export const findActiveSubscription = subscriptions =>
  (subscriptions || []).find(
    subscription => !subscription.ends_at || new Date(subscription.ends_at) > new Date()
  ) || null;

export const selectSubscriptionProvider = ({ User }) =>
  findActiveSubscription(User?.data?.subscriptions)?.platform || null;

// Only api/user?billing=1 returns this, so it is null until Account is loaded.
export const selectUpdatePaymentUrl = ({ Account }) =>
  Account?.data?.stripeSubscription?.management_urls?.update_payment_method || null;

/**
 * Which payment provider the user is currently subscribed through, and the
 * provider-hosted URL for updating their card when there is one.
 *
 * `provider` comes from User.data, which always carries subscriptions, so it
 * is answerable even when Account has not been fetched. `updatePaymentUrl`
 * needs Account, so callers must tolerate it being null.
 */
const useSubscriptionProvider = () => {
  const provider = useSelector(selectSubscriptionProvider);
  const updatePaymentUrl = useSelector(selectUpdatePaymentUrl);

  return {
    provider,
    isPaddle: provider === PLATFORM_PADDLE,
    updatePaymentUrl,
  };
};

export default useSubscriptionProvider;
